import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "ContentHomeTrackrecord home-trackrecord" }
const _hoisted_2 = { class: "page-container home-trackrecord__container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InvestmentsTrackrecord = _resolveComponent("InvestmentsTrackrecord")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("h4", { class: "home-trackrecord__title" }, " Investors from every state are building their land portfolios with AcreTrader: ", -1)),
      _createVNode(_component_InvestmentsTrackrecord)
    ])
  ]))
}